import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"


const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const getUserTransactionAction = createAsyncThunk(
    'get-user-transaction',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/users/api/my-transaction`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getUserTransactionSlice = createSlice({
    name: 'get-user-transaction',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getUserTransactionAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getUserTransactionAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(getUserTransactionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const getUserTransactionReducer = getUserTransactionSlice.reducer